<template>
  <v-container fluid>
    <v-layout>
      <v-flex md6>
        <v-card>
          <v-card-title primary-title>
            <h3 class="headline mb-0">月次運賃・請求支払管理（凍結）</h3>
          </v-card-title>
          <v-card-actions>
            <v-btn
              @click="search()"
              class="btn-search"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_ARAP_SEARCH
              >{{ $t('app.buttons.search') }}</v-btn
            >
            <v-btn
              @click="openReportDialog()"
              v-if="true"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_AP_DOWNLOAD
              >AP支払出力</v-btn
            >
            <v-btn
              @click="arDownload"
              v-if="true"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD
              >AR請求出力</v-btn
            >
            <v-btn
              @click="downloadV2('ap_zx_detail')"
              v-if="true"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD
              >ＡＰ－ＺＸ明細出力</v-btn
            >

            <v-btn
              @click="downloadV2('ar_zx_detail')"
              v-if="true"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD
              >ＡＲ－ＺＸ明細出力</v-btn
            >
          </v-card-actions>
          <v-card-actions>
            <v-btn
              @click="downloadV2('ar_ap_profit')"
              v-if="true"
              v-permit.SHARP_FU_AR_AP_PROFIT_DOWNLOAD
              >月度利益内訳出力</v-btn
            >
          </v-card-actions>
          <v-form>
            <v-container fluid>
              <v-layout>
                <v-flex md3 sm6 xs12>
                  <date-picker
                    label="月次"
                    type="month"
                    v-model="query.yearMonth"
                  ></date-picker>
                </v-flex>
                <v-flex md3 sm6 xs12>
                  <remote-autocomplete
                    :label="$t('app.labels.bu.name')"
                    url="divisions/kv?type=BU"
                    v-model="query.buId"
                  />
                </v-flex>
                <v-flex md3 sm6 xs12>
                  <remote-autocomplete
                    label="サプライヤー"
                    url="companies/kvt?type=SUPPLIER"
                    v-model="query.supplierId"
                  ></remote-autocomplete>
                </v-flex>
                <v-flex md3 sm6 xs12>
                  <v-text-field
                    label="doNo"
                    v-model="query.doNo"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
      <v-flex md6>
        <v-card style="height: 170px">
          <v-card-title primary-title>
            <h3 class="headline mb-0">月次運賃・請求支払管理（速報）</h3>
          </v-card-title>
          <v-card-actions>
            <v-btn
              @click="downloadV2('ap_archive/quick_report')"
              v-if="true"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_AP_DOWNLOAD
              >AP支払出力</v-btn
            >
            <v-btn
              @click="downloadV2('ar_archive/quick_report')"
              v-if="true"
              v-permit.SHARP_FU_ARCHIVE_MONTHLY_AR_DOWNLOAD
              >AR請求出力</v-btn
            >

            <v-btn
              @click="downloadV2('ar_ap_profit/quick_report')"
              v-if="true"
              v-permit.SHARP_FU_AR_AP_PROFIT_DOWNLOAD
              >月度利益内訳出力</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-card class="mt-2">
      <v-card-title primary-title>
        <div>
          <span class="headline mb-0">検索結果表示</span>
        </div>
      </v-card-title>
      <v-tabs v-model="tab">
        <v-tab>業者支払</v-tab>
        <v-tab-item>
          <v-card :class="ptableStyle">
            <payment-table
              :query="query"
              @detail="paymentShow"
              ref="payment"
            ></payment-table>

            <div style="verticial-align: top; width: 100%">
              <detail-info-table
                @closeDetail="pClose"
                @showAnalysisInfo="showAnalysisInfo"
                ref="paymentDetail"
                v-show="pShow"
              ></detail-info-table>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab>事業本部請求</v-tab>
        <v-tab-item>
          <v-card :class="rtableStyle">
            <request-table
              :query="query"
              @detail="requestShow"
              ref="request"
            ></request-table>
            <div style="verticial-align: top; width: 100%">
              <detail-info-table
                @closeDetail="rClose"
                @showAnalysisInfo="showAnalysisInfo"
                ref="requestDetail"
                v-show="rShow"
              ></detail-info-table>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab>BL支払請求</v-tab>
        <v-tab-item>
          <bl-payment-table ref="blInformation"></bl-payment-table>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <v-dialog v-model="analysisShow">
      <analysis-info
        @analysisClose="analysisShow = false"
        ref="analysisInfo"
      ></analysis-info>
    </v-dialog>
    <v-dialog v-model="reportDialog" width="30%">
      <v-card>
        <v-container grid-list-md>
          <v-card-text>
            <v-layout row wrap>
              <v-flex
                :key="title.value"
                md12
                pl-4
                sm12
                v-for="title in reportTitle"
                xs12
              >
                <v-radio-group v-model="report">
                  <v-radio
                    :disabled="title.isDisabled"
                    :label="`${title.text}`"
                    :value="title.value"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap>
              <v-flex md12 pl-4 sm12 xs12>
                <v-btn @click="downloadReport" color="blue">出力</v-btn>
                <v-btn @click="closeReportDialog" color="blue">閉じる</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import paymentTable from './paymentTable'
import requestTable from './requestTable'
import blPaymentTable from './blPaymentTable'
import detailInfoTable from './detailInfoTable'
import analysisInfo from './analysisInfo'

export default {
  components: {
    paymentTable,
    requestTable,
    blPaymentTable,
    detailInfoTable,
    analysisInfo,
  },
  data() {
    return {
      ptableStyle: 'tableBefore',
      rtableStyle: 'tableBefore',
      pShow: false,
      rShow: false,
      report: null,
      reportDialog: false,
      reportTitle:[],
      analysisShow: false,
      detailShow: false,
      tab: null,
      results: [],
      selected: [],
      loading: false,
      monthlyFare: [],
      query: {},
      pagination: {
        page: 1,
      },

      month: null,
      monthlyHeaders: [
        { text: '日期', value: 'date', sortable: false },
        { text: '核算区分', value: 'accountingDistinction', sortable: false },
        { text: 'D/O No.', value: 'doNo', sortable: false },
        { text: '枝番', value: 'branchCode', sortable: false },
        { text: '金额', value: 'amount', sortable: false },
        { text: '借方会计科目', value: 'debitAccount', sortable: false },
        { text: '贷方会计科目', value: 'creditAccount', sortable: false },
      ],
      headers: [
        { text: '社内品番', value: 'skuCode', sortable: false },
        { text: 'D/O NO', value: 'doNo', sortable: false },
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: '積出港', value: 'loadingPortName', sortable: false },
        { text: 'ETD', value: 'etd', sortable: false },
        { text: '陸揚港', value: 'dischargePortName', sortable: false },
        { text: 'ETA', value: 'eta', sortable: false },
        { text: '納入場所', value: 'finallyWarehouseName', sortable: false },
        { text: '納入予定日', value: 'forecastDeliveryDate', sortable: false },
        { text: '事業本部', value: 'buHeadquartersName', sortable: false },
        { text: '事業部', value: 'departmentName', sortable: false },
        { text: '部品区分', value: 'itemClassification', sortable: false },
        { text: 'フレイト費', value: 'freightFee', sortable: false },
        { text: '諸掛', value: 'variousTimes', sortable: false },
        { text: '諸掛確定日', value: 'variousTimesDate', sortable: false },
      ],
    }
  },
  methods: {
    openReportDialog(){
      this.$http.get(`/arap/reports/ap_archive/status_map?yearMonth=${this.query.yearMonth}`).then(res => {
        this.reportDialog=true;
        this.reportTitle=[
        { text: 'Jusda1~月末AP（海上航空）「履歴１~20日」', value: 1, isDisabled: !res.data[1] },
        {
          text: '「履歴」Jusda21～月末AP（海上航空）',
          value: 2,
          isDisabled:!res.data[2],
        },
        {
          text: '非JusdaAP（海上航空）',
          value: 3,
          isDisabled: !res.data[3],
        },
        { text: '諸掛费用AP', value: 4, isDisabled: !res.data[4] },
        {
          text: '全量AP(Jusda+非Jusda)',
          value: 5,
          isDisabled: !res.data[5] ,
        },
        // { text: '非jusda国际段', value: 5 }
      ]
      });
    },
    showAnalysisInfo(doNo) {
      this.$refs.analysisInfo.load(doNo, () => (this.analysisShow = true))
    },
   
   
    closeReportDialog() {
      this.report = null
      this.reportDialog = false
    },
    downloadReport() {
      if (this.report === 1) {
        this.downloadV2(
          'ap_archive',
          'paymentDateType=OneToTwenty&isJusda=true&reportType=1'
        )
      } else if (this.report === 2) {
        this.downloadV2(
          'ap_archive',
          'paymentDateType=TwentyOneToEnd&isJusda=true&reportType=2'
        )
      } else if (this.report === 3) {
        this.downloadV2(
          'ap_archive',
          'isJusda=false&paymentDateType=international&reportType=3'
        )
      } else if (this.report === 4) {
        this.downloadV2(
          'ap_archive',
          'isJusda=false&paymentDateType=LOCAL&reportType=4'
        )
      } else if (this.report === 5) {
        this.downloadV2('ap_archive', 'reportType=5')
      }
    },
    downloadV2(path, params) {
      return this.$download(
        `/arap/reports/${path}?yearMonth=${this.query.yearMonth}&${params}`
      )
    },
    arDownload() {
      this.downloadV2('ar_archive')
    },

    paymentShow(item) {
      this.ptableStyle = 'tableAfter'
      this.rshow = false
      this.pShow = true
      this.$refs.paymentDetail.search(item, 'payment')
    },
    requestShow(item) {
      this.rtableStyle = 'tableAfter'
      this.pShow = false
      this.rShow = true
      this.$refs.requestDetail.search(item, 'request')
    },
    pClose() {
      this.ptableStyle = 'tableBefore'
      this.pShow = false
    },
    rClose() {
      this.rtableStyle = 'tableBefore'
      this.rShow = false
    },
    search() {
      if (this.tab === 0) {
        this.$refs.payment.search()
      }
      if (this.tab === 1) {
        this.$refs.request.search()
      }
      if (this.tab === 2) {
        this.$refs.blInformation.load(this.query.doNo)
      }
    },
  },
  mounted() {
    // this.$loadParams()
    let date = new Date()
    date.setMonth(date.getMonth() - 1)
    this.query.yearMonth = date.format('yyyy-MM')
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
<style scoped>
div.v-card__text {
  padding: 0px;
}
div.v-card div.v-card__title {
  padding: 8px;
}

.tableBefore {
  display: block;
}

.tableAfter {
  display: -webkit-box;
  display: -ms-flexbox;
  overflow-x: scroll !important;
  display: flex;
}
</style>
